import * as React from 'react';

import { RsvpYes, Message } from '../../reducers/root';
import BaseForm from './baseForm';
import InputErrorMessage from './inputErrorMessage';

interface RsvpFormProps {
  yesRsvps: RsvpYes[];
  onSubmit: (message: Message) => void;
}

interface RsvpFormState {
  message: string;
  showErrors: boolean;
}

const defaultState: RsvpFormState = {
  message: '',
  showErrors: false,
};

export default class RsvpForm extends BaseForm<RsvpFormProps, RsvpFormState> {
  state = { ...defaultState };

  onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!this.state.message) {
      this.setState({ showErrors: true });
      return;
    }

    const phoneNumbers = Object.keys(this.props.yesRsvps).map(key => this.props.yesRsvps[key].phoneNumber);

    this.props.onSubmit({
      message: this.state.message,
      status: 'created',
      phoneNumbers,
    });
    this.setState({ ...defaultState });
  };

  render(): JSX.Element {
    return (
      <form>
        <div className="field control">
          <label className="label">Message everyone who is coming</label>
          <textarea
            className="textarea"
            name="message"
            value={this.state.message}
            onChange={this.onValueChange}
            placeholder="This will be the exact text of the message sent out"
          />
          <InputErrorMessage showError={!this.state.message && this.state.showErrors} message="Enter message text" />
        </div>

        <div className="field control">
          <button className="button is-dark" onClick={this.onSubmit}>
            Send to attendees!
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/sendMessageForm.tsx